import { LinkifiedText } from '@/components/LinkifiedText';
import { ApprovingInvoiceReportFormInputResponse } from '@/context/services/approving_invoice_reports/type';
import { FC, memo } from 'react';

type TextAreaFieldViewProps = {
  item: ApprovingInvoiceReportFormInputResponse;
};

export const TextAreaFieldView: FC<TextAreaFieldViewProps> = memo(
  ({ item }) => {
    return <LinkifiedText text={item.input_values?.[0]?.label ?? ''} />;
  }
);

TextAreaFieldView.displayName = 'TextAreaFieldView';
